export const environment = {
  production: true,
  baseUrl: 'https://api.solarspektarag.mk',
  version: require('../../package.json').version
};
